var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex flex-col bg-gray-100 h-screen"},[_c('Menu'),_c('router-view',{key:_vm.$route.path,staticClass:"flex flex-col flex-grow relative pt-10"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }